import CollaboratorsResumeService from "../services/api/collaborators/CollaboratorsResume.service";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { RefreshReactQuery } from "../constants/AppConstants";
import { UpdateCollaboratorResumeRequest } from "../types/api/collaborators.type";
import { useEffect } from "react";
import { useNotification } from "./notification.hook";
import { ERROR_LABEL, ERROR_MESSAGE_LABEL } from "../constants/Dictionary";

export const useCollaboratorResume = (
  collaboratorId: number | null,
  enabled = true,
) => {
  const { notification } = useNotification();
  const { data, isFetching, isError } = useQuery({
    queryKey: ["get-collaborator-resume", collaboratorId],
    queryFn: () => CollaboratorsResumeService.get(collaboratorId!),
    staleTime: RefreshReactQuery.MODERATE,
    enabled: collaboratorId !== null && enabled,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isFetching };
};

export const useUpdateCollaboratorResume = (collaboratorId: number) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (body: UpdateCollaboratorResumeRequest) =>
      CollaboratorsResumeService.update(collaboratorId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get-collaborator-resume", collaboratorId],
      });
    },
  });

  return { updateResume: mutateAsync, isUpdating: isPending };
};
